            import React from 'react';
            import {Typography, Box, Button, List, ListItem, ListItemText, TextField} from '@mui/material';
            import { styled } from "@mui/material/styles";
            import spinnerImage from '../../../../assets/images/dq-spinner.png';
            import CombinedEditableSection from './CombinedEditableSection.comp';
            import { tUi } from '../../../../utils/dq_lc';

            const SlideContainer = styled(Box)`
              display: flex;
              flex-direction: column;
              height: 100%;
              padding: 20px 0;
            `;
            export const SlideWithImage = styled(Box)(({ theme }) => ({
                display: "flex",
                gap: 0,
                alignItems: "center",
                width: "100%",
                minHeight: "50vh",

                [theme.breakpoints.down("lg")]: {
                    flexDirection: "column",
                },
            }));

            export const SlideImageContainer = styled(Box)`
              flex: 1;
              height:100%;
              display: flex;
              justify-content: center;
              align-items: center;
            `;

            export const SlideImage = styled(Image)`
              max-width: 100%;
              max-height: 460px;
              object-fit: contain;
              border-radius: 8px;
              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
              transition: transform 0.2s ease;
            `;

            export const SlidePointsContainer = styled(Box)`
              flex: 1;
            `;

            export const SlideTitleContainer = styled(Box)`
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                flex: 1;
            `;

            // Single point with larger image
            export const SlideSinglePointWithImage = styled(Box)`
              display: flex;
              flex-direction: column;
              gap: 30px;
              width: 100%;
            `;
            export const SlidePoint = styled(Box)`
              padding: 20px 0;
              border-radius: 8px;
              transition: transform 0.2s ease;
            `;

            export const PointTitle = styled(Typography)`
              margin-top: 0;
              margin-bottom: 10px;
              font-size: 18px;
              color: #000;
              font-weight: 600;
            `;

            export const PointText = styled(Typography)`
              margin: 0;
              color: #000;
              line-height: 1.6;
              font-size: 20px;
              text-align: left;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;


            export const SinglePoint = styled(SlidePoint)`
              max-width: 100%;
              font-size: 1.1em;
            `;

            const SlideTitle = styled(Typography)(({ theme }) => ({
                width:'100%',
                textAlign: "left",
                marginBottom: "30px",
                fontSize: "35px",
                color: "#EE6D29",
                fontWeight: 700,
                position: "relative",
                paddingBottom: "15px",
                userSelect: "none",
                WebkitUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitUserDrag: "none",
                pointerEvents: "auto",

                [theme.breakpoints.down("sm")]: {
                    fontSize: "23px",
                    marginBottom: "5px",
                },
            }));


            export const SlideList = styled(Box)`
                  padding: 20px 0;
                  border-radius: 8px;
                   min-height: 47vh;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
                  
                  ul {
                    padding-left: 20px;
                    text-align: left;
                  }
                
                  li {
                    margin-bottom: 12px;
                    font-size: clamp(16px, 2vw, 21px);
                    color: #000;
                    line-height: 1.6;
                    list-style-type: disc;
                  }
                `;

            const ContentContainer = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
            `;

            const ImagePlaceholder = styled(Box)`
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 75%;
              height: auto;
              min-height: 200px;
              margin: 16px auto;
              overflow: hidden;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
            `;

            export const StepBlockContainer = styled(Box)(({ theme }) => ({
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "30px",
                marginBottom: "30px",
                [theme.breakpoints.down("lg")]: {
                    flexWrap: "wrap",
                    overflow: "auto",
                    justifyContent: "flex-start",
                    scrollSnapType: "y mandatory",
                    "-webkit-overflow-scrolling": "touch",
            },
            }));

            export const TitleBox = styled(Box)(({ theme }) => ({
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start"
            }));

            export const StepColumn = styled(Box)(({ theme, stepcount }) => {
                const count = Number(stepcount) || 4;
                
                let flexBasis, maxWidth, minHeight, maxHeight;
                
                if (count === 1) {
                    flexBasis = "45%";
                    maxWidth = "200px";
                    minHeight = "100%";
                    maxHeight = "100%";
                } else if (count === 2) {
                    flexBasis = "45%";
                    maxWidth = "470px";
                    minHeight = "300px";
                    maxHeight = "none";
                } else if (count === 3) {
                    flexBasis = "32%";
                    maxWidth = "240px";
                    minHeight = "230px";
                    maxHeight = "none";
                } else {
                    flexBasis = "24%";
                    maxWidth = "200px";
                    minHeight = "300px";
                    maxHeight = "none";
                }
                
                return {
                    flex: `0 1 ${flexBasis}`,
                    maxWidth: maxWidth,
                    minWidth: "200px",
                    minHeight: minHeight,
                    maxHeight: maxHeight,
                    borderRadius: "10px",
                    padding: "16px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                    [theme.breakpoints.down("sm")]: {
                        width: "250px",
                        maxWidth: "250px",
                        minWidth: "250px",
                    },
                };
            });

            export const StepTitle = styled(Typography)(({ theme, iscondensed }) => ({
                textAlign: "center",
                fontWeight: 600,
                marginBottom: "12px",
                lineHeight: 1.2,
                userSelect: "none",
                WebkitUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitUserDrag: "none",
                pointerEvents: "auto",
                color: "#EE6D29",
                fontSize: iscondensed ? "22px" : "26px",

                [theme.breakpoints.down("sm")]: {
                    minHeight: "unset",
                },
            }));

            export const StepText = styled(Typography)`
                text-align: left;
              line-height: 1.5;
              color: #000;
                font-size: ${(props) => (props.iscondensed ? '18px' : '20px')};
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;

            export const ContentBulletItem = styled(Box)`
              display: flex;
              margin-bottom: 12px;
              line-height: 1.6;
              text-align: left;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;

              &::before {
                content: "•";
                font-size: 24px;
                color: #000;
                margin-right: 12px;
                flex-shrink: 0;
                line-height: 1.6;
              }
            `;

            export const ContentItemText = styled(Typography)`
              font-size: 20px;
              color: #000;
              line-height: 1.6;
              
              strong {
                font-weight: 700;
              }
            `;

            export const ContentSubheading = styled(Typography)`
              font-weight: 700;
              font-size: 22px;
              color: #000;
              margin-top: 20px;
              margin-bottom: 10px;
              line-height: 1.4;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;

            export const ContentText = styled(Typography)`
              font-size: 20px;
              color: #000;
              line-height: 1.6;
              margin-bottom: 15px;
              text-align: left;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;

            export const SlideDescription = styled(Box)`
              line-height: 1.7;
              color: #000;
              font-size: 18px;
              padding: 20px 0;
              max-width: 100%;
              border-radius: 8px;
                min-height: 50vh;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;

            export const VideoLayout = styled(Box)`
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              /* padding: 40px; */
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;

            export const ActivityContainer = styled(Box)`
              display: flex;
              flex-direction: row;
              gap: 40px;
              padding: 20px;
              max-width: 1100px;
              margin: 0 auto;
              align-items: flex-start;
            `;

            export const ActivityColumnContainer = styled(ActivityContainer)`
              flex-direction: column;
              align-items: center;
            `;

            export const ActivityLeft = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
            `;

            // Activity Pill with Pointed Corner
            export const ActivityPill =  styled(Box)`
              width: 55%;
              position: relative;
              display: block;
              background: #000000;
              color: white;
              padding: 12px 16px 12px 0;
              font-size: 18px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              border-radius: 0 20px 0 0;
              margin-bottom: 12px;
              margin-left: 0;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
              
              @media (max-width: 768px) {
                padding: 6px 12px 6px 10px;
                font-size: 11px;
                
                &::after {
                  bottom: -6px;
                  border-width: 6px 6px 0 0;
                }
              }
            `;

              export const FullActivityPill = styled(ActivityPill)`
              width: 100%;
              text-align: center;
            `;

            export const ActivityRight = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            `;

            export const ActivityHeader = styled(Box)`
              text-align: center;
              //max-width: 700px;
            `;

            export const ActivityTitle = styled(Typography)`
              font-size: 42px;
              color: #EE6D29;
              font-weight: 700;
              margin-bottom: 16px;
              text-align: left;
              margin-top: 0;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;

            export const ActivityPollTitle = styled(ActivityTitle)`
              text-align: center;
            `;

            export const ActivityContent = styled(Box)`
              text-align: left;  
              font-size: 18px;
              line-height: 1.6;
              color: #000;
              white-space: pre-line;
            `;

            export const JournalingTextArea = styled(Box)`
              width: 100%;
              min-height: 300px;
              padding: 16px;
              border: 2px solid #FF7676;
              border-radius: 8px;
              background-color: #fff;
              font-size: 16px;
              font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
              line-height: 1.5;
              resize: vertical;
              transition: border-color 0.2s ease;

              &:focus {
                outline: none;
                border-color: #FF7676;
                box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
              }

              &::placeholder {
                color: #a0aec0;
              }
            `;

            export const PledgeLayout = styled(Box)`
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              gap: 24px;
              width: 100%;
            `;

            export const LeftContent = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
            `;

            export const HtmlContentLayout = styled(Box)`
              display: flex;
              gap: 24px;
              width: 100%;
              align-items: flex-start;
              
              @media (max-width: 960px) {
                flex-direction: column;
              }
            `;

            export const HtmlImageContainer = styled(Box)`
              flex: 0 0 40%;
              display: flex;
              justify-content: center;
              align-items: flex-start;
              
              @media (max-width: 960px) {
                flex: 1;
                width: 100%;
              }
            `;

            export const HtmlContentColumn = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
            `;

            export const HtmlContentWrapper = styled(Box)`
              width: 100%;
              line-height: 1.6;
              font-size: 18px;
              color: #000;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              
              & * {
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                -webkit-user-drag: none;
                pointer-events: auto;
              }
            `;

            export const RightBox = styled(Box)`
              flex: 1;
              margin: 20px;
              margin-top: 60px;
              background-color: #0097b2;
              border-radius: 12px;
              padding: 24px;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            `;

            export const IconWrapper = styled(Box)`
              margin-bottom: 16px;
              svg {
                font-size: 48px;
                color: #fff;
              }
            `;

            export const PledgeDescription = styled(Typography)`
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              margin-bottom: 24px;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;

            export const SubmitButton = styled(Button)`
              align-self: center;
              padding: 12px 32px;
              background-color: #FF7676;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 16px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s ease;
              margin-top: 16px;

              &:hover {
                background-color: #FF7676;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              }

              &:active {
                transform: translateY(0);
              }

              &:disabled {
                background-color: #DDDDDD;
                cursor: not-allowed;
                transform: none;
              }
            `;

            export const SaveButton = styled(SubmitButton)`
              background-color: #FF7676;

              &:hover {
                background-color: #FF7676;
              }

              &:disabled {
                background-color: #DDDDDD;
              }
            `;

            export const Text = styled(Box)`
              text-align: center;
              font-weight: 600;
              color: #000000;
              margin: 10px auto;
              font-size: 22px;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
            `;


            export const LinkInput = styled(TextField)`
              width: 60%;
              margin: 10px auto;
              background-color: #fff !important;
              
              & .MuiOutlinedInput-root {
                font-size: 16px;
                font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
                
                & fieldset {
                  border: 2px solid #0097B2;
                  border-radius: 8px;
                }
                
                &:hover fieldset {
                  border-color: #0097B2;
                }
                
                &.Mui-focused fieldset {
                  border-color: #0097B2;
                  box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.15);
                }
              }
              
              & .MuiInputBase-input {
                color: #000;
                padding: 16px;
              }
              
              & .MuiInputBase-input::placeholder {
                color: #a0aec0;
                opacity: 1;
              }
            `;

            export const FileUploadButton = styled(Button)`
              padding: 10px 20px;
              background-color: #0097B2;
              border: none;
              border-radius: 6px;
              color: #ffffff;
              font-size: 18px;
              font-weight: 600;
              cursor: pointer;
              display: block;
              margin: 10px auto;
              width: 60%;
              transition: all 0.2s ease;
              &:hover {
                background-color: #0097B2;
              }
            `;

            // Poll/Quiz activity styles
            export const PollContainer = styled(Box)`
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              gap: 16px;
              width: 100%;
            `;

            export const PollOption = styled(Box)`
              flex: 0 1 calc(20% - 16px);
              min-width: 180px;
              max-width: 300px;
              padding: 16px;
              border: 2px solid #0097B2;
              border-radius: 8px;
              cursor: pointer;
              transition: all 0.2s ease;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: ${props => (props.selected ? '#0097B2' : '#fff')};
              color: ${props => (props.selected ? '#fff' : '#000')};
              font-size: 16px;
              font-weight: 500;
            
              &:hover {
                border-color: #0097B2;
              }
            `;

            export const PollOptionText = styled(Typography)`
              font-size: 16px;
              font-weight: 500;
            `;

            export const ActivityWrapper = styled(Box)`
              position: relative;
              width: 100%;
            `;

            export const DiscussionButton = styled(Button)`
              padding: 16px 40px;
              background-color: #0097B2;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 18px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s ease;
              margin-top: 24px;
              margin-bottom: 16px;
              min-width: 200px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              text-transform: none;
                
              /* Add icon styling */
              i {
                font-size: 16px;
              }
              `;

            // Assessment Result Styles
            export const AssessmentResultContainer = styled(Box)`
              padding: 30px 20px 0;
              width: 100%;
              text-align: center;
            `;

            export const ResultContent = styled(Box)`
              text-align: center;
            `;

            export const ResultHeading = styled(Box)`
              font-weight: bold;
              margin-top: 4vh;
              font-size: 2em;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
              
              h1 {
                font-size: 2em;
                margin-top: 4vh;
                color: #ED6628;
                font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
                
                @media (max-width: 768px) {
                  font-size: 1.5em;
                }
              }
            `;

            export const ResultBody = styled(Box)`
              font-weight: 400;
            `;

            export const ScoreContainer = styled(Box)`
                display: flex;
                justify-content: space-around;
                margin-left: auto;
                margin-right: auto;
                margin-top: 4vh;
                width: 100%;

                @media (max-width: 768px) {
                    display: block;
                    margin-top: 0;
                    width: 100%;
                }

                @media (max-width: 1024px) {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 100%;
                }
            `;

            export const ScoreContent = styled(Box)`
                padding: 0 6vh;
              
              @media (max-width: 768px) {
                width: 100%;
                padding: 0;
              }
            `;

            export const ScoreSpinner = styled(Box)`
                background: url(${spinnerImage}) no-repeat center center;
                background-size: contain;
                padding: 10%;
                width: 15vw;
                height: 15vw;
                max-width: 250px;
                max-height: 250px;
                font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;

                /* Responsive font size - scales with container */
                font-size: clamp(1.8em, 6vw, 3.2em);

                @media (max-width: 1024px) {
                    width: 30vw;
                    height: 30vw;
                    font-size: clamp(1.6em, 5.5vw, 2.8em);
                }

                @media (max-width: 768px) {
                    width: 35vw;
                    height: 35vw;
                    font-size: clamp(1.4em, 5vw, 2.2em);
                }

                @media (max-width: 480px) {
                    width: 45vw;
                    height: 45vw;
                    font-size: clamp(1.2em, 4vw, 1.8em);
                }

                /* Ensure the spinner maintains aspect ratio */
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
            `;

            export const ScoreLabelPt = styled('span')`
              margin-top: -5px;
            `;

            export const ScoreDesc = styled(Box)`
              font-size: 1.3em;
              font-weight: bold;
              padding: 0.5em 1em;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
              
              @media (max-width: 768px) {
                font-size: 1.1em;
                margin-bottom: 1vh;
              }
            `;

            export const RubricContainer = styled(Box)`
                display: flex;
                background-color: #f4f2f3;
                border-radius: 15px;
                padding: 10px 18px;
                width: fit-content;
                max-width: 100%;
                overflow-y: auto;
                scroll-snap-type: y;

                @media (max-width: 768px) {
                    padding: 8px 10px;
                    width: fit-content;
                    max-width: 90vw;
                }

                @media (min-width: 768px) and (max-width: 1024px) {
                    margin-left: auto;
                    margin-right: auto;
                }
            `;

            export const RubricContent = styled(Box)`
              text-align: left;
              width: 100%;
            `;

            export const RubricRowWrapper = styled(Box)`
              display: flex;
              flex-direction: row;
            `;

            export const RubricScores = styled(Box)`
                display: flex;
                width: 50px;
                text-align: right;
                padding-right: 10px;
                flex-direction: column;
                justify-content: flex-start;
                font-family: 'Lemon/Milk';
                font-size: 1.3rem;
                margin-top: -11px;

                span {
                    width: 40px;
                    font-weight: bold;
                    margin-bottom: -15px;
                    color: ${props => props.scoreColor || '#000'};
                }

                @media (max-width: 768px) {
                    font-size: 1.1rem;
                }
            `;

            export const RubricRowContent = styled(Box)`
              display: flex;
              padding: 8px 15px;
              border-left: 12px solid;
              margin-bottom: 2px;
              min-height: 50px;
              align-items: center;
              flex: 1;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
              pointer-events: auto;
              
              span {
                display: flex;
                align-items: center;
                font-weight: 800;
                font-size: 1.3rem;
                width: 100%;
                line-height: 20px;
              }
              
              @media (max-width: 768px) {
                padding: 6px 12px;
                min-height: 40px;
                
                span {
                  font-size: 1rem;
                }
              }
            `;

            export const RubricExcellent = styled(RubricRowContent)`
              border-color: #3cc6f3;
              span {
                color: #3cc6f3;
              }
            `;

            export const RubricAboveAvg = styled(RubricRowContent)`
              border-color: #f5a335;
              span {
                color: #f5a335;
              }
            `;

            export const RubricBelowAvg = styled(RubricRowContent)`
              border-color: #838383;
              span {
                color: #838383;
              }
            `;

            export const RubricReqAtt = styled(RubricRowContent)`
              border-color: #ff00c6;
              span {
                color: #ff00c6;
              }
            `;


const SlideComponentV2 = ({ 
  slide, 
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  videoUrl,
  videoSubtitles,
  langCode,
  uiLocale = 'en-US',
}) => {
  // console.log('SlideComponentV2 props:', slide);
    const titleRefs = React.useRef([]);
    const [maxTitleHeight, setMaxTitleHeight] = React.useState(0);
  const [selectedPollOption, setSelectedPollOption] = React.useState(null);

    React.useEffect(() => {
        if (!Array.isArray(slide?.SlideContent)) return;
        const heights = titleRefs.current.slice(0, slide.SlideContent.length).map(el => el?.offsetHeight || 0);
        const max = Math.max(...heights);
        if (max !== maxTitleHeight) {
            setMaxTitleHeight(max);
        }
    }, [slide]);

  if (!slide) return null;

  const renderTitle = () => {
    if (!slide.SlideTitle) return null;
    
    const titleEdit = slideEdits['title'];
    const displayTitle = showEnglishContent ? (titleEdit?.original || slide.SlideTitle) : (titleEdit?.edited || slide.SlideTitle);
    const hasHtmlTags = /<[^>]+>/.test(displayTitle);
    
    // Simple display - editing handled by CombinedEditableSection
    return (
      <SlideTitle>
        {hasHtmlTags ? (
          <span dangerouslySetInnerHTML={{ __html: displayTitle }} />
        ) : (
          highlightWord ? highlightWord('title', displayTitle) : displayTitle
        )}
      </SlideTitle>
    );
  };

  const handlePollOptionClick = (index) => {
    setSelectedPollOption(index);
  };
  const renderTextWithId = (id, text, Component = PointText, extraProps = {}) => {
    if (text == null) return null;
    // Normalize text to string when possible
    let normalized = text;
    if (Array.isArray(normalized)) {
      // Flatten array to string of primitive / stringifiable values
      normalized = normalized
        .map(v => (typeof v === 'string' ? v : (v && typeof v === 'object' ? Object.values(v).filter(x=> typeof x === 'string').join(' ') : '')))
        .filter(Boolean)
        .join(' ');
    } else if (typeof normalized === 'object') {
      normalized = Object.values(normalized).filter(v => typeof v === 'string').join(' ');
    }
    if (typeof normalized !== 'string') {
      normalized = String(normalized);
    }
    if (!normalized.trim()) return null;
    
    // Get edit state for this field
    const fieldEdit = slideEdits[id];
    const displayText = showEnglishContent ? (fieldEdit?.original || normalized) : (fieldEdit?.edited || normalized);

    // Check if content contains HTML tags (check both original and edited)
    const hasHtmlTags = /<[^>]+>/.test(normalized) || /<[^>]+>/.test(displayText);

    // Simple rendering - editing handled by CombinedEditableSection
    const contentToRender = displayText;
    if (hasHtmlTags) {
      // sanitize incorrect HTML tags first
      let sanitized = contentToRender.replace(/<li\s*\/>/gi, '</li>');

      let content = sanitized;
      if (highlightWord) {
        const highlighted = highlightWord(id, sanitized);
        // If highlightWord returns a string, use it; otherwise use original
        content = typeof highlighted === 'string' ? highlighted : sanitized;
      }
      
      return (
        <Component 
          {...extraProps}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      );
    } else {
      // Plain text without HTML - use normal rendering with highlighting
      return (
        <Component {...extraProps}>
          {highlightWord ? highlightWord(id, contentToRender) : contentToRender}
        </Component>
      );
    }
  };

  const renderContent = () => {
    switch (slide.SlideLayout) {
      case 'TemplateGraphicAndText':
        return (
          <>
            <SlideWithImage>
              {slide.Images && slide.Images.length > 0 && (
                <SlideImageContainer>
                  <ImagePlaceholder>
                    <img
                      src={slide.Images[0]}
                      alt="Slide image"
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        borderRadius: '4px',
                        pointerEvents: 'none',
                        WebkitUserDrag: 'none',
                      }}
                    />
                  </ImagePlaceholder>
                </SlideImageContainer>
              )}
              <SlidePointsContainer>
                <SlidePoint>
                  {isEditMode ? (
                    <CombinedEditableSection
                      slide={slide}
                      isEditMode={isEditMode}
                      slideEdits={slideEdits}
                      showEnglishContent={showEnglishContent}
                      onSave={onSaveEdit}
                      onReset={onResetEdit}
                      onCancel={onCancelEdit}
                      TitleComponent={SlideTitle}
                      ContentComponent={PointText}
                    />
                  ) : (
                    <>
                      {renderTitle()}
                      {renderTextWithId('content_0', slide.SlideContent)}
                    </>
                  )}
                </SlidePoint>
              </SlidePointsContainer>
            </SlideWithImage>
          </>
        );

      case 'TemplateSessionStart':
        return (
          <SlideWithImage>
            {slide.Images && slide.Images.length > 0 && (
              <SlideImageContainer>
                <ImagePlaceholder>
                  <img
                    src={slide.Images[0]}
                    alt="Slide image"
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '4px',
                      pointerEvents: 'none',
                      WebkitUserDrag: 'none',
                    }}
                  />
                </ImagePlaceholder>
              </SlideImageContainer>
            )}
            <SlideTitleContainer>
              <SlidePoint>
                {isEditMode ? (
                  <CombinedEditableSection
                    slide={slide}
                    isEditMode={isEditMode}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    onSave={onSaveEdit}
                    onReset={onResetEdit}
                    onCancel={onCancelEdit}
                    TitleComponent={SlideTitle}
                    ContentComponent={PointText}
                  />
                ) : (
                  <>
                    {renderTitle()}
                    {renderTextWithId('content_0', slide.SlideContent)}
                  </>
                )}
              </SlidePoint>
            </SlideTitleContainer>
          </SlideWithImage>
        );

      case 'TemplateList': {
        const content = slide.SlideContent;
        const isString = typeof content === 'string';
        const hasListTags = isString && /<(ul|ol|li)[\s>]/i.test(content);
        
        return (
          <SlideList>
            {isEditMode ? (
              <CombinedEditableSection
                slide={slide}
                isEditMode={isEditMode}
                slideEdits={slideEdits}
                showEnglishContent={showEnglishContent}
                onSave={onSaveEdit}
                onReset={onResetEdit}
                onCancel={onCancelEdit}
                TitleComponent={SlideTitle}
                ContentComponent={PointText}
              />
            ) : (
              <>
                {renderTitle()}
                {hasListTags || !Array.isArray(content) ? (
                  renderTextWithId('content_0', content)
                ) : (
                  <ul>
                    {content.map((item, idx) => (
                      <li key={idx}>
                        {renderTextWithId(`content_${idx}`, item)}
                      </li>
                    ))}
                  </ul>
                )}
              </>
            )}
          </SlideList>
        );
      }

      case 'TemplateLongText':
        return (
          <SlideDescription>
            {isEditMode ? (
              <CombinedEditableSection
                slide={slide}
                isEditMode={isEditMode}
                slideEdits={slideEdits}
                showEnglishContent={showEnglishContent}
                onSave={onSaveEdit}
                onReset={onResetEdit}
                onCancel={onCancelEdit}
                TitleComponent={SlideTitle}
                ContentComponent={PointText}
              />
            ) : (
              <>
                {renderTitle()}
                {renderTextWithId('content_0', slide.SlideContent)}
              </>
            )}
          </SlideDescription>
        );

      case 'TEMPLATE_WITH_SUBTITLE':
        return (
          <SlideDescription>
            {isEditMode ? (
              <CombinedEditableSection
                slide={slide}
                isEditMode={isEditMode}
                slideEdits={slideEdits}
                showEnglishContent={showEnglishContent}
                onSave={onSaveEdit}
                onReset={onResetEdit}
                onCancel={onCancelEdit}
                TitleComponent={SlideTitle}
                ContentComponent={PointText}
              />
            ) : (
              <>
                {renderTitle()}
                {Array.isArray(slide.SlideContent) && slide.SlideContent.map((item, idx) => (
                  <ContentBulletItem key={idx}>
                    <ContentItemText>
                      {item.SubTitle && (
                        <>
                          <strong>{item.SubTitle.trim()}:</strong>{' '}
                        </>
                      )}
                      {item.Text && (highlightWord ? highlightWord(`content_${idx}_text`, item.Text) : item.Text)}
                    </ContentItemText>
                  </ContentBulletItem>
                ))}
              </>
            )}
          </SlideDescription>
        );

     case 'TemplateStepBlock': {
            const isCondensed = Array.isArray(slide.SlideContent) && slide.SlideContent.length > 3;
            const stepCount = Array.isArray(slide.SlideContent) ? slide.SlideContent.length : 0;
            const containerStyle = stepCount === 1 ? { justifyContent: 'center' } : {};

            return (
                <SlideDescription>
                    {slide.SlideTitle && (() => {
                        const titleEdit = slideEdits['title'];
                        const displayTitle = showEnglishContent 
                          ? (titleEdit?.original || slide.SlideTitle)
                          : (titleEdit?.edited || slide.SlideTitle);
                        return (
                            <SlideTitle style={{ textAlign: 'center' }}>
                                {highlightWord ? highlightWord('title', displayTitle) : displayTitle}
                            </SlideTitle>
                        );
                    })()}
                    <StepBlockContainer style={containerStyle}>
                        {Array.isArray(slide.SlideContent) &&
                            slide.SlideContent.map((step, idx) => (
                                <StepColumn key={idx} stepcount={stepCount}>
                                  {isEditMode ? (
                                      <CombinedEditableSection
                                          slide={{...slide,
                                              SlideTitle: step.Title,
                                              SlideContent: step.Text,
                                          }}
                                          isEditMode={isEditMode}
                                          slideEdits={{
                                              title: slideEdits[`content_${idx}_title`],
                                              content_0: slideEdits[`content_${idx}_text`],
                                          }}
                                          showEnglishContent={showEnglishContent}
                                          onSave={(field, edit) => {
                                              if (field === 'title') {
                                                  onSaveEdit(`content_${idx}_title`, edit);
                                              }
                                              if (field === 'content_0') {
                                                  onSaveEdit(`content_${idx}_text`, edit);
                                              }
                                          }}
                                          onReset={(field) => {
                                              onResetEdit(`content_${idx}_${field === 'title' ? 'title' : 'text'}`);
                                          }}
                                          onCancel={(field) => {
                                              onCancelEdit(`content_${idx}_${field === 'title' ? 'title' : 'text'}`);
                                          }}
                                          TitleComponent={StepTitle}
                                          ContentComponent={StepText}
                                          contentExtraProps={{ iscondensed: isCondensed }}
                                      />
                                  ) : (
                                      <>
                                      <TitleBox
                                          ref={el => (titleRefs.current[idx] = el)}
                                          style={{
                                              minHeight: maxTitleHeight || "auto",
                                          }}
                                      >
                                          {renderTextWithId(`content_${idx}_title`, step.Title, StepTitle, { iscondensed: isCondensed })}
                                      </TitleBox>
                                      {renderTextWithId(`content_${idx}_text`, step.Text, StepText, { iscondensed: isCondensed })}
                                      </>
                                  )}
      
                              </StepColumn>
                          ))}
                  </StepBlockContainer>
              </SlideDescription>
          );
      }

      case 'PledgeTemplate':
        return (
          <PledgeLayout>
            <LeftContent>
              {isEditMode ? (
                <CombinedEditableSection
                  slide={slide}
                  isEditMode={isEditMode}
                  slideEdits={slideEdits}
                  showEnglishContent={showEnglishContent}
                  onSave={onSaveEdit}
                  onReset={onResetEdit}
                  onCancel={onCancelEdit}
                  TitleComponent={SlideTitle}
                  ContentComponent={PointText}
                />
              ) : (
                <>
                  {renderTitle()}
                  {renderTextWithId('content_0', slide.SlideContent)}
                </>
              )}
            </LeftContent>

            <RightBox>
              <IconWrapper />
              <PledgeDescription>{slide.SlidePledgeContent}</PledgeDescription>
              <SubmitButton>I pledge</SubmitButton>
            </RightBox>
          </PledgeLayout>
        );

      case 'VideoTemplate':
        const subtitleUrl = videoSubtitles || slide.IntroVideoVtt || slide.IntroVideoSrt;
        const resolvedVideoUrl = videoUrl || slide.VideoUrl || slide.IntroVideo;

        return (
          <VideoLayout>
            {isEditMode ? (
              <>
                {resolvedVideoUrl && (
                  <Box sx={{
                      width: '85%',
                      maxWidth: '1300px',
                      minWidth: '700px',
                      minHeight: '370px',
                      maxHeight: '60vh',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                  }}>
                      <video
                          controls
                          crossOrigin="anonymous"
                          controlsList="nodownload"
                          style={{
                              width: '100%',
                              height: '100%',
                              maxHeight: '100%',
                              display: 'block',
                              objectFit: 'contain',
                          }}
                          src={resolvedVideoUrl}
                      >
                          Your browser does not support the video tag.
                          {subtitleUrl && (
                              <track
                                  kind="subtitles"
                                  src={subtitleUrl}
                                  srcLang={langCode || 'en'}
                                  label={langCode ? langCode.toUpperCase() : 'English'}
                                  default={true}
                              />
                          )}
                      </video>
                  </Box>
                )}
                <CombinedEditableSection
                  slide={slide}
                  isEditMode={isEditMode}
                  slideEdits={slideEdits}
                  showEnglishContent={showEnglishContent}
                  onSave={onSaveEdit}
                  onReset={onResetEdit}
                  onCancel={onCancelEdit}
                  TitleComponent={SlideTitle}
                  ContentComponent={PointText}
                  titleExtraProps={{ style: { textAlign: 'center' } }}
                />
              </>
            ) : (
              <>
                {slide.SlideTitle && (
                  <SlideTitle style={{ textAlign: 'center' }}>
                    {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
                  </SlideTitle>
                )}
                {resolvedVideoUrl && (
                  <Box sx={{
                      width: '85%',
                      maxWidth: '1300px',
                      minWidth: '700px',
                      minHeight: '370px',
                      maxHeight: '60vh',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                  }}>
                      <video
                          controls
                          crossOrigin="anonymous"
                          controlsList="nodownload"
                          style={{
                              width: '100%',
                              height: '100%',
                              maxHeight: '100%',
                              display: 'block',
                              objectFit: 'contain',
                          }}
                          src={resolvedVideoUrl}
                      >
                          Your browser does not support the video tag.
                          {subtitleUrl && (
                              <track
                                  kind="subtitles"
                                  src={subtitleUrl}
                                  srcLang={langCode || 'en'}
                                  label={langCode ? langCode.toUpperCase() : 'English'}
                                  default={true}
                              />
                          )}
                      </video>
                  </Box>
                )}
                {renderTextWithId('content_0', slide.SlideContent)}
              </>
            )}
          </VideoLayout>
        );

      case 'JOURNALING_SELF_REFLECTION_ACTIVITY':
        return (
          <ActivityContainer>
            <ActivityLeft>
                <FullActivityPill>{tUi('slide.activity.journalingTime', uiLocale)}</FullActivityPill>
                {isEditMode ? (
                  <CombinedEditableSection
                    slide={slide}
                    isEditMode={isEditMode}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    onSave={onSaveEdit}
                    onReset={onResetEdit}
                    onCancel={onCancelEdit}
                    TitleComponent={SlideTitle}
                    ContentComponent={ActivityContent}
                  />
                ) : (
                  <>
                    {renderTitle()}
                    {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
                  </>
                )}
            </ActivityLeft>
            <ActivityRight>
              <JournalingTextArea placeholder={tUi('slide.activity.journalingPlaceholder', uiLocale)} />
              <SaveButton>{tUi('slide.activity.save', uiLocale)}</SaveButton>
            </ActivityRight>
          </ActivityContainer>
        );

      case 'SHARE_WORK_FILE_ACTIVITY':
        return (
          <ActivityContainer>
            <ActivityLeft>
                <FullActivityPill>{tUi('slide.activity.shareWorkTime', uiLocale)}</FullActivityPill>
                {isEditMode ? (
                  <CombinedEditableSection
                    slide={slide}
                    isEditMode={isEditMode}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    onSave={onSaveEdit}
                    onReset={onResetEdit}
                    onCancel={onCancelEdit}
                    TitleComponent={SlideTitle}
                    ContentComponent={ActivityContent}
                  />
                ) : (
                  <>
                    {renderTitle()}
                    {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
                  </>
                )}
            </ActivityLeft>
            <ActivityRight>
              <LinkInput
                variant="outlined"
                type="url"
                placeholder={tUi('slide.activity.shareLinkPlaceholder', uiLocale)}
              />
              <SubmitButton>{tUi('slide.activity.submit', uiLocale)}</SubmitButton>
            </ActivityRight>
          </ActivityContainer>
        );

      case 'POLL_QUIZ_ACTIVITY':
        return (
          <ActivityColumnContainer>
            <ActivityHeader>
                <ActivityPill>{tUi('slide.activity.pollTime', uiLocale)}</ActivityPill>
                {isEditMode ? (
                  <CombinedEditableSection
                    slide={slide}
                    isEditMode={isEditMode}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    onSave={onSaveEdit}
                    onReset={onResetEdit}
                    onCancel={onCancelEdit}
                    TitleComponent={SlideTitle}
                    ContentComponent={ActivityContent}
                  />
                ) : (
                  <>
                    {renderTitle()}
                    {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
                  </>
                )}
            </ActivityHeader>
            <PollContainer>
              {Array.isArray(slide.Options) && slide.Options.map((option, idx) => (
                <PollOption 
                  key={idx}
                  selected={selectedPollOption === idx}
                  onClick={() => handlePollOptionClick(idx)}
                >
                  {renderTextWithId(`poll_option_${idx}`, option, PollOptionText)}
                </PollOption>
              ))}
            </PollContainer>
            <SubmitButton>{tUi('slide.activity.submit', uiLocale)}</SubmitButton>
          </ActivityColumnContainer>
        );

        case 'DISCUSSION_ACTIVITY':
        return (
              <ActivityWrapper>
                  <ActivityColumnContainer>
                      {/* Header */}
                      <ActivityHeader>
                          <ActivityPill>{tUi('slide.activity.discussionTime', uiLocale)}</ActivityPill>
                          {isEditMode ? (
                            <CombinedEditableSection
                              slide={slide}
                              isEditMode={isEditMode}
                              slideEdits={slideEdits}
                              showEnglishContent={showEnglishContent}
                              onSave={onSaveEdit}
                              onReset={onResetEdit}
                              onCancel={onCancelEdit}
                              TitleComponent={ActivityTitle}
                              ContentComponent={ActivityContent}
                            />
                          ) : (
                            <>
                              <ActivityTitle>
                                  {renderTitle()}
                              </ActivityTitle>
                              <ActivityContent> {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}</ActivityContent>
                            </>
                          )}
                      </ActivityHeader>

                      {/* Discussion Button */}
                      <DiscussionButton>
                          {tUi('slide.activity.letsTalkAboutIt', uiLocale)}
                      </DiscussionButton>
                  </ActivityColumnContainer>
              </ActivityWrapper>
        );

      case 'ASSESSMENT_RESULT':
        const localizeAssessmentScoreTitle = (rawTitle) => {
          if (!rawTitle) return rawTitle;
          if (!uiLocale || uiLocale === 'en-US') return rawTitle;
          const m = String(rawTitle).match(/^\s*Your Module\s*(\d+)\s*Assessment Score\s*$/i);
          if (m) return tUi('slide.assessment.moduleScoreTitle', uiLocale, { module: m[1] });
          if (String(rawTitle).trim().toLowerCase() === 'your module assessment score') {
            return tUi('slide.assessment.moduleScoreTitleGeneric', uiLocale);
          }
          return rawTitle;
        };

        const localizedResultTitle = localizeAssessmentScoreTitle(slide.SlideTitle);
        return (
          <AssessmentResultContainer>
            <ResultContent>
                <SlideTitle style={{textAlign:'center'}}>
                    {highlightWord ? highlightWord('title', localizedResultTitle) : localizedResultTitle}
                </SlideTitle>
              <ResultBody>
                <ScoreContainer>
                  <ScoreContent>
                    <ScoreSpinner>
                      <span>{parseFloat(slide.SlideContent?.score || 0).toFixed(2).split('.')[0]}</span>
                      <ScoreLabelPt>.{parseFloat(slide.SlideContent?.score || 0).toFixed(2).split('.')[1]}</ScoreLabelPt>
                    </ScoreSpinner>
                    <ScoreDesc>{slide.SlideContent?.description || tUi('slide.activity.yourModuleScore', uiLocale)}</ScoreDesc>
                  </ScoreContent>
                  <div>
                    <RubricContainer>
                        <RubricContent>
                            <RubricRowWrapper>
                                <RubricScores scoreColor="#3cc6f3">
                                    <span>100</span>
                                </RubricScores>
                                <RubricExcellent>
                                    <span>{tUi('slide.activity.excellent', uiLocale)}</span>
                                </RubricExcellent>
                            </RubricRowWrapper>
                            <RubricRowWrapper>
                                <RubricScores scoreColor="#f5a335">
                                    <span>75</span>
                                </RubricScores>
                                <RubricAboveAvg>
                                    <span>{tUi('slide.activity.good', uiLocale)}</span>
                                </RubricAboveAvg>
                            </RubricRowWrapper>
                            <RubricRowWrapper>
                                <RubricScores scoreColor="#838383">
                                    <span>50</span>
                                </RubricScores>
                                <RubricBelowAvg>
                                    <span>{tUi('slide.activity.canImprove', uiLocale)}</span>
                                </RubricBelowAvg>
                            </RubricRowWrapper>
                            <RubricRowWrapper>
                                <RubricScores scoreColor="#ff00c6">
                                    <span>25</span>
                                    <span style={{ color: '#000000', marginTop: 'auto' }}>0</span>
                                </RubricScores>
                                <RubricReqAtt>
                                    <span>{tUi('slide.activity.requiresAttention', uiLocale)}</span>
                                </RubricReqAtt>
                            </RubricRowWrapper>
                        </RubricContent>
                    </RubricContainer>
                  </div>
                </ScoreContainer>
              </ResultBody>
            </ResultContent>
          </AssessmentResultContainer>
        );

      case 'TemplateHtmlContent':
        const htmlContent = typeof slide.SlideContent === 'string' 
          ? slide.SlideContent 
          : Array.isArray(slide.SlideContent) 
            ? slide.SlideContent.join('') 
            : String(slide.SlideContent || '');

        if (slide.Images && slide.Images.length > 0) {
          return (
            <HtmlContentLayout>
              <HtmlImageContainer>
                <ImagePlaceholder>
                  <img
                    src={slide.Images[0]}
                    alt="Slide image"
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '4px',
                      pointerEvents: 'none',
                      WebkitUserDrag: 'none',
                    }}
                  />
                </ImagePlaceholder>
              </HtmlImageContainer>
              <HtmlContentColumn>
                {isEditMode ? (
                  <CombinedEditableSection
                    slide={slide}
                    isEditMode={isEditMode}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    onSave={onSaveEdit}
                    onReset={onResetEdit}
                    onCancel={onCancelEdit}
                    TitleComponent={SlideTitle}
                    ContentComponent={HtmlContentWrapper}
                  />
                ) : (
                  <>
                    {slide.SlideTitle && slide.SlideTitle.trim() && (
                      <SlideTitle>
                        {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
                      </SlideTitle>
                    )}
                    <HtmlContentWrapper
                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                    />
                  </>
                )}
              </HtmlContentColumn>
            </HtmlContentLayout>
          );
        } else {
          return (
            <HtmlContentColumn>
              {isEditMode ? (
                <CombinedEditableSection
                  slide={slide}
                  isEditMode={isEditMode}
                  slideEdits={slideEdits}
                  showEnglishContent={showEnglishContent}
                  onSave={onSaveEdit}
                  onReset={onResetEdit}
                  onCancel={onCancelEdit}
                  TitleComponent={SlideTitle}
                  ContentComponent={HtmlContentWrapper}
                />
              ) : (
                <>
                  {slide.SlideTitle && slide.SlideTitle.trim() && (
                    <SlideTitle>
                      {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
                    </SlideTitle>
                  )}
                  <HtmlContentWrapper
                    dangerouslySetInnerHTML={{ __html: htmlContent }}
                  />
                </>
              )}
            </HtmlContentColumn>
          );
        }

      default:
        return (
          <Typography variant="body1" color="error">
            Unsupported slide layout: {slide.SlideLayout}
          </Typography>
        );
    }
  };

  return (
    <SlideContainer>
      <ContentContainer>{renderContent()}</ContentContainer>
    </SlideContainer>
  );
};

export default SlideComponentV2;